import React from 'react';

const About = () => {
    return <>
        <section id="about" className='section'>
            <div className="my-3">
                <h2 className='g'>My portofolio</h2>
                <p>
                    This is my modest portofolio, It contains some of my best projects chosen by me,
                    and information about me. I am so interesting for new opportunities and new ideas.
                </p>
            </div>
            <div className="my-3">
                <h2 className='g'>About me</h2>
                <p>My name is yahia mahmoud, My age is "{(new Date().getFullYear()) - 2005}". I live in Alexandria in Egypt. I speak Arabic and English </p>
            </div>
            <div className="my-3">
                <h3 className='g'>My study</h3>
                <p>I studied primary and prep in a private school in Egypt, I applied for stem schools and I
                    was accepted in stem hurghada but I did not go because of long distance and I joined ordinary high school instead 
                    and now I am studying at the "Faculty of Computers and Data Science, Alexandria University", my expected year of graduation is 2027,I have started learning programming at the end of 2020.</p>
            </div>
            <div className="my-3">
                <h3 className='g'>my hobbies</h3>
                <p>I love programming, mathematics and cycling, I
                    am used to getting up early at 5 AM even in holidays.</p>
            </div>
        </section>
    </>
}

export default About;